import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";
import Layout from "../components/dashboard/main";

const Main = lazy(() => import("../components/transcript/applyForTranscript"));

const ApplyForTranscript = () => {
  return (
    <Layout pageHeading="Transcript" >
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    </Layout>
  );
};

export default ApplyForTranscript;
